// import {
//   Box,
//   Grid,
//   Button,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   styled,
//   Dialog,
//   DialogContent,
// } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import dayjs from "dayjs";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import JobCard from "../../components/Cards/JobCard";
// import JobAllocationAttendence from "../../components/Utility/JobAllocationAttendence";
// import WorkOrderModal from "../../components/Utility/WorkOrderModal";
// import JobAllocationService from "../../service/JobAllocationService";
// import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   "& .MuiDialogContent-root": {
//     padding: theme.spacing(2),
//   },
//   "& .MuiDialogActions-root": {
//     padding: theme.spacing(1),
//   },
// }));

// const Job_Allocation = () => {
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [jobData, setJobData] = useState([]);
//   const [unassignedList, setUnassignedList] = useState([]);
//   const [contractors, setContractors] = useState([]);
//   const [contractorCode, setContractorCode] = useState("");

//   useEffect(() => {
//     const fetchContractors = async () => {
//       try {
//         const response = await JobAllocationService.GetContracters();
//         const result = response.data?.ResultSet || [];
//         const options = result
//           .map((item) => ({
//             code:
//               item.Contractor_Code ??
//               item.CONTRACTOR_CODE ??
//               item.ContractorCode ??
//               item.CON_CODE ??
//               item.CODE,
//             name:
//               item.Contractor_Name ??
//               item.CONTRACTOR_NAME ??
//               item.ContractorName ??
//               item.CONTRACTOR_DESCRIPTION ??
//               item.DESCRIPTION ??
//               item.NAME,
//           }))
//           .filter((item) => item.code !== undefined && item.code !== null);

//         setContractors(options);
//         setContractorCode((currentCode) => currentCode || String(options[0]?.code || ""));
//       } catch (error) {
//         console.error("Error fetching contractors:", error);
//         setContractors([]);
//       }
//     };

//     fetchContractors();
//   }, []);

//   useEffect(() => {
//     const fetchJobData = async () => {
//       const formattedDate = selectedDate.format("YYYY-MM-DD");

//       try {
//         const jobCardResponse = await JobAllocationService.GetJobCard(
//           formattedDate,
//           contractorCode
//         );
//         if (jobCardResponse.data.StatusCode === 200) {
//           setJobData(jobCardResponse.data.ResultSet);
//         } else {
//           setJobData([]);
//         }

//         const unassignedListResponse =
//           await JobAllocationService.GetUnAssignedList(
//             formattedDate,
//             contractorCode
//           );
//         if (unassignedListResponse.data.StatusCode === 200) {
//           setUnassignedList(unassignedListResponse.data.ResultSet);
//         } else {
//           setUnassignedList([]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setJobData([]);
//         setUnassignedList([]);
//       }
//     };

//     fetchJobData();
//   }, [selectedDate, contractorCode]);

//   const handleOpenModal = (type) => {
//     setOpenModal(true);
//     setModalType(type);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//   };

//   const handleDateChange = async (newValue) => {
//     setSelectedDate(newValue);
//   };

//   const [modalType, setModalType] = useState("");

//   return (
//     <div>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexDirection: { xs: "column", sm: "row" },
//           gap: 1.5,
//           p: { xs: 1.5, sm: 2 },
//           backgroundColor: "#ffffff",
//           border: "1px solid #dbe7f3",
//           borderLeft: "4px solid #1976d2",
//           borderRadius: 2,
//           boxShadow: "0 4px 14px rgba(25, 118, 210, 0.08)",
//           mb: 2,
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: 1,
//             width: { xs: "100%", sm: "auto" },
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               mr: { xs: 0, sm: 1.5 },
//               width: { xs: "100%", sm: "auto" },
//             }}
//           >
//             <AssignmentTurnedInIcon sx={{ color: "#1976d2", fontSize: 25 }} />
//             <Box>
//               <Typography
//                 variant="subtitle1"
//                 sx={{ fontWeight: 700, lineHeight: 1.1, color: "#16324f" }}
//               >
//                 Job Allocation
//               </Typography>
//             </Box>
//           </Box>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 0.5,
//               color: "#526579",
//               fontWeight: 600,
//               flexShrink: 0,
//               width: { xs: "calc(50% - 4px)", sm: 220 },
//               minWidth: 0,
//             }}
//           >
//             <CalendarMonthIcon sx={{ fontSize: 16, color: "#1976d2" }} />
//             <Typography variant="body2" sx={{ fontWeight: 700 }}>
//               Date
//             </Typography>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 value={selectedDate}
//                 onChange={handleDateChange}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     size="small"
//                     sx={{ width: { xs: "calc(100% - 38px)", sm: 110 } }}
//                   />
//                 )}
//               />
//             </LocalizationProvider>
//           </Box>
//           <FormControl
//             size="small"
//             sx={{
//               width: { xs: "calc(50% - 4px)", sm: 220 },
//               flex: "initial",
//               minWidth: 0,
//               maxWidth: { xs: "100%", sm: 220 },
//               ml: { xs: 0, sm: 1 },
//               "& .MuiInputLabel-root": { fontSize: 12 },
//               "& .MuiSelect-select": { fontSize: 12 },
//             }}
//           >
//             <InputLabel id="contractor-label" sx={{ fontSize: 12 }}>
//               Contractor
//             </InputLabel>

//             <Select
//               labelId="contractor-label"
//               value={contractorCode}
//               label="Contractor"
//               onChange={(event) => setContractorCode(event.target.value)}
//               MenuProps={{
//                 PaperProps: {
//                   sx: {
//                     maxHeight: 250,
//                     overflowY: "auto",
//                     "& .MuiMenuItem-root": {
//                       fontSize: 10,
//                       minHeight: 28,
//                       py: 0.5,
//                       lineHeight: 1.2,
//                     },
//                   },
//                 },
//               }}
//             >
//               {contractors.map((contractor) => (
//                 <MenuItem
//                   key={contractor.code}
//                   value={String(contractor.code)}
//                   sx={{
//                     fontSize: 10,
//                     minHeight: 28,
//                     py: 0.5,
//                     lineHeight: 1.2,
//                   }}
//                 >
//                   {contractor.name || contractor.code}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>

//         <Box
//           sx={{
//             display: "flex",
//             gap: 1,
//             ml: { xs: 0, sm: 2 },
//             width: { xs: "100%", sm: "auto" },
//             justifyContent: { xs: "flex-end", sm: "initial" },
//           }}
//         >
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => handleOpenModal("attendance")}
//             sx={{
//               backgroundColor: "#007bff",
//               color: "white",
//               textTransform: "none",
//             }}
//           >
//             Attendance
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => handleOpenModal("new")}
//             sx={{
//               backgroundColor: "#007bff",
//               color: "white",
//               textTransform: "none",
//             }}
//           >
//             New
//           </Button>
//         </Box>
//       </Box>

//       <JobCard
//         jobData={jobData}
//         unassignedList={unassignedList}
//         selectedDate={selectedDate}
//         contractorCode={contractorCode}
//       />

//       <BootstrapDialog
//         onClose={handleCloseModal}
//         aria-labelledby="customized-dialog-title"
//         open={openModal}
//       >
//         <DialogContent>
//           {/* {modalType === 'attendance' && <JobAllocationAttendence />} */}
//           {modalType === "attendance" && (
//             <JobAllocationAttendence
//               onClose={handleCloseModal}
//               selectedDate={selectedDate.format("YYYY-MM-DD")}
//               contractorCode={contractorCode}
//             />
//           )}
//           {modalType === "new" && (
//             <WorkOrderModal
//               onClose={handleCloseModal}
//               contractorCode={contractorCode}
//             />
//           )}
//         </DialogContent>
//       </BootstrapDialog>
//     </div>
//   );
// };

// export default Job_Allocation;



// --------------------- 2026-09-25 latest comment--------------------------

// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   styled,
//   Dialog,
//   DialogContent,
// } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import dayjs from "dayjs";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import JobCard from "../../components/Cards/JobCard";
// import JobAllocationAttendence from "../../components/Utility/JobAllocationAttendence";
// import WorkOrderModal from "../../components/Utility/WorkOrderModal";
// import JobAllocationService from "../../service/JobAllocationService";
// import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//   "& .MuiDialogContent-root": {
//     padding: theme.spacing(2),
//   },
//   "& .MuiDialogActions-root": {
//     padding: theme.spacing(1),
//   },
// }));

// const Job_Allocation = () => {
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [jobData, setJobData] = useState([]);
//   const [unassignedList, setUnassignedList] = useState([]);
//   const [contractors, setContractors] = useState([]);
//   const [contractorCode, setContractorCode] = useState("");
//   const [modalType, setModalType] = useState("");

//   useEffect(() => {
//     const fetchContractors = async () => {
//       try {
//         const response = await JobAllocationService.GetContracters();
//         const result = response.data?.ResultSet || [];
//         const options = result
//           .map((item) => ({
//             code:
//               item.Contractor_Code ??
//               item.CONTRACTOR_CODE ??
//               item.ContractorCode ??
//               item.CON_CODE ??
//               item.CODE,
//             name:
//               item.Contractor_Name ??
//               item.CONTRACTOR_NAME ??
//               item.ContractorName ??
//               item.CONTRACTOR_DESCRIPTION ??
//               item.DESCRIPTION ??
//               item.NAME,
//           }))
//           .filter((item) => item.code !== undefined && item.code !== null);

//         setContractors(options);
//         setContractorCode(
//           (currentCode) => currentCode || String(options[0]?.code || "")
//         );
//       } catch (error) {
//         console.error("Error fetching contractors:", error);
//         setContractors([]);
//       }
//     };

//     fetchContractors();
//   }, []);

//   useEffect(() => {
//     const fetchJobData = async () => {
//       const formattedDate = selectedDate.format("YYYY-MM-DD");

//       try {
//         const jobCardResponse = await JobAllocationService.GetJobCard(
//           formattedDate,
//           contractorCode
//         );
//         if (jobCardResponse.data.StatusCode === 200) {
//           setJobData(jobCardResponse.data.ResultSet);
//         } else {
//           setJobData([]);
//         }

//         const unassignedListResponse =
//           await JobAllocationService.GetUnAssignedList(
//             formattedDate,
//             contractorCode
//           );
//         if (unassignedListResponse.data.StatusCode === 200) {
//           setUnassignedList(unassignedListResponse.data.ResultSet);
//         } else {
//           setUnassignedList([]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setJobData([]);
//         setUnassignedList([]);
//       }
//     };

//     fetchJobData();
//   }, [selectedDate, contractorCode]);

//   const handleOpenModal = (type) => {
//     setOpenModal(true);
//     setModalType(type);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//   };

//   const handleDateChange = async (newValue) => {
//     setSelectedDate(newValue);
//   };

//   // ✅ Both Date & Contractor boxes get EXACTLY the same size
//   const filterBoxSx = {
//     width: { xs: "50%", sm: 220 },
//     height: 40,
//     flexShrink: 0,
//     minWidth: 0,
//   };

//   return (
//     <div>
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexDirection: { xs: "column", sm: "row" },
//           gap: 1.5,
//           p: { xs: 1.5, sm: 2 },
//           backgroundColor: "#ffffff",
//           border: "1px solid #dbe7f3",
//           borderLeft: "4px solid #1976d2",
//           borderRadius: 2,
//           boxShadow: "0 4px 14px rgba(25, 118, 210, 0.08)",
//           mb: 2,
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: 1,
//             width: { xs: "100%", sm: "auto" },
//           }}
//         >
//           {/* Title */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               mr: { xs: 0, sm: 1.5 },
//               width: { xs: "100%", sm: "auto" },
//             }}
//           >
//             <AssignmentTurnedInIcon sx={{ color: "#1976d2", fontSize: 25 }} />
//             <Typography
//               variant="subtitle1"
//               sx={{ fontWeight: 700, lineHeight: 1.1, color: "#16324f" }}
//             >
//               Job Allocation
//             </Typography>
//           </Box>

//           {/* Date + Contractor - EXACT SAME SIZE, SAME ROW */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               width: { xs: "100%", sm: "auto" },
//               flexWrap: "nowrap",
//             }}
//           >
//             {/* ✅ Date Box - same size as Contractor */}
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 value={selectedDate}
//                 onChange={handleDateChange}
//                 format="DD/MM/YYYY"
//                 slotProps={{
//                   textField: {
//                     size: "small",
//                     sx: {
//                       ...filterBoxSx,
//                       "& .MuiInputBase-root": {
//                         height: 40,
//                         fontSize: 12,
//                       },
//                       "& .MuiInputBase-input": {
//                         fontSize: 12,
//                         padding: "8px 10px",
//                       },
//                     },
//                   },
//                 }}
//               />
//             </LocalizationProvider>

//             {/* ✅ Contractor Box - same size as Date + dropdown icon always visible */}
//             <FormControl
//               size="small"
//               sx={{
//                 ...filterBoxSx,
//                 "& .MuiInputBase-root": {
//                   height: 40,
//                   fontSize: 12,
//                 },
//                 "& .MuiInputLabel-root": { fontSize: 12 },
//               }}
//             >
//               <InputLabel id="contractor-label" sx={{ fontSize: 12 }}>
//                 Contractor
//               </InputLabel>
//               <Select
//                 labelId="contractor-label"
//                 value={contractorCode}
//                 label="Contractor"
//                 onChange={(event) => setContractorCode(event.target.value)}
//                 MenuProps={{
//                   PaperProps: {
//                     sx: {
//                       maxHeight: 250,
//                       overflowY: "auto",
//                       "& .MuiMenuItem-root": {
//                         fontSize: 10,
//                         minHeight: 28,
//                         py: 0.5,
//                         lineHeight: 1.2,
//                       },
//                     },
//                   },
//                 }}
//                 sx={{
//                   // ✅ Truncate long text with "..." so icon stays visible
//                   "& .MuiSelect-select": {
//                     fontSize: 12,
//                     padding: "8px 10px",
//                     paddingRight: "32px !important",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                     display: "block",
//                     lineHeight: "24px",
//                   },
//                   // ✅ Dropdown arrow always visible
//                   "& .MuiSelect-icon": {
//                     right: 8,
//                     fontSize: 20,
//                     color: "#1976d2",
//                     pointerEvents: "none",
//                   },
//                 }}
//               >
//                 {contractors.map((contractor) => (
//                   <MenuItem
//                     key={contractor.code}
//                     value={String(contractor.code)}
//                     sx={{
//                       fontSize: 10,
//                       minHeight: 28,
//                       py: 0.5,
//                       lineHeight: 1.2,
//                     }}
//                   >
//                     {contractor.name || contractor.code}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>
//         </Box>

//         {/* Buttons */}
//         <Box
//           sx={{
//             display: "flex",
//             gap: 1,
//             ml: { xs: 0, sm: 2 },
//             width: { xs: "100%", sm: "auto" },
//             justifyContent: { xs: "flex-end", sm: "initial" },
//           }}
//         >
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => handleOpenModal("attendance")}
//             sx={{
//               backgroundColor: "#007bff",
//               color: "white",
//               textTransform: "none",
//             }}
//           >
//             Attendance
//           </Button>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => handleOpenModal("new")}
//             sx={{
//               backgroundColor: "#007bff",
//               color: "white",
//               textTransform: "none",
//             }}
//           >
//             New
//           </Button>
//         </Box>
//       </Box>

//       <JobCard
//         jobData={jobData}
//         unassignedList={unassignedList}
//         selectedDate={selectedDate}
//         contractorCode={contractorCode}
//       />

//       <BootstrapDialog
//         onClose={handleCloseModal}
//         aria-labelledby="customized-dialog-title"
//         open={openModal}
//       >
//         <DialogContent>
//           {modalType === "attendance" && (
//             <JobAllocationAttendence
//               onClose={handleCloseModal}
//               selectedDate={selectedDate.format("YYYY-MM-DD")}
//               contractorCode={contractorCode}
//             />
//           )}
//           {modalType === "new" && (
//             <WorkOrderModal
//               onClose={handleCloseModal}
//               contractorCode={contractorCode}
//             />
//           )}
//         </DialogContent>
//       </BootstrapDialog>
//     </div>
//   );
// };

// export default Job_Allocation;





// --------------------- 2026-09-25--------------------------
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  styled,
  Dialog,
  DialogContent,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import JobCard from "../../components/Cards/JobCard";
import JobAllocationAttendence from "../../components/Utility/JobAllocationAttendence";
import WorkOrderModal from "../../components/Utility/WorkOrderModal";
import JobAllocationService from "../../service/JobAllocationService";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 16,
    margin: theme.spacing(1.5),
    width: "100%",
    maxWidth: 520,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const formatTime = (value) => {
  if (!value) return "—";
  return value.split(/[ T]/).pop() || "—";
};

const Job_Allocation = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [jobData, setJobData] = useState([]);
  const [unassignedList, setUnassignedList] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [contractorCode, setContractorCode] = useState("");
  const [modalType, setModalType] = useState("");
  const [allocatedEmployees, setAllocatedEmployees] = useState([]);
  const [allocatedEmployeesLoading, setAllocatedEmployeesLoading] =
    useState(false);
  const [allocatedEmployeesError, setAllocatedEmployeesError] = useState("");

  useEffect(() => {
    const fetchContractors = async () => {
      try {
        const response = await JobAllocationService.GetContracters();
        const result = response.data?.ResultSet || [];
        const options = result
          .map((item) => ({
            code:
              item.Contractor_Code ??
              item.CONTRACTOR_CODE ??
              item.ContractorCode ??
              item.CON_CODE ??
              item.CODE,
            name:
              item.Contractor_Name ??
              item.CONTRACTOR_NAME ??
              item.ContractorName ??
              item.CONTRACTOR_DESCRIPTION ??
              item.DESCRIPTION ??
              item.NAME,
          }))
          .filter((item) => item.code !== undefined && item.code !== null);

        setContractors(options);
        setContractorCode(
          (currentCode) => currentCode || String(options[0]?.code || "")
        );
      } catch (error) {
        console.error("Error fetching contractors:", error);
        setContractors([]);
      }
    };

    fetchContractors();
  }, []);

  useEffect(() => {
    const fetchJobData = async () => {
      const formattedDate = selectedDate.format("YYYY-MM-DD");

      try {
        const jobCardResponse = await JobAllocationService.GetJobCard(
          formattedDate,
          contractorCode
        );
        if (jobCardResponse.data.StatusCode === 200) {
          setJobData(jobCardResponse.data.ResultSet);
        } else {
          setJobData([]);
        }

        const unassignedListResponse =
          await JobAllocationService.GetUnAssignedList(
            formattedDate,
            contractorCode
          );
        if (unassignedListResponse.data.StatusCode === 200) {
          setUnassignedList(unassignedListResponse.data.ResultSet);
        } else {
          setUnassignedList([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setJobData([]);
        setUnassignedList([]);
      }
    };

    fetchJobData();
  }, [selectedDate, contractorCode]);

  const handleOpenModal = (type) => {
    setOpenModal(true);
    setModalType(type);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleViewAllocatedEmployees = async () => {
    setModalType("allocated");
    setOpenModal(true);
    setAllocatedEmployees([]);
    setAllocatedEmployeesError("");
    setAllocatedEmployeesLoading(true);

    try {
      const response = await JobAllocationService.GetAllocatedEmp(
        selectedDate.format("YYYY-MM-DD"),
        contractorCode
      );
      if (response.data?.StatusCode === 200) {
        setAllocatedEmployees(response.data.ResultSet || []);
      } else {
        //setAllocatedEmployeesError("Unable to load allocated employees.");
      }
    } catch (error) {
      
    } finally {
      setAllocatedEmployeesLoading(false);
    }
  };

  const handleDateChange = async (newValue) => {
    setSelectedDate(newValue);
  };

  // ✅ Shared field styles (compact & pretty)
  const fieldSx = {
    flex: 1,
    minWidth: 0,
    "& .MuiInputBase-root": {
      height: 38,
      fontSize: 12,
      borderRadius: 2,
      backgroundColor: "#f8fafc",
    },
    "& .MuiInputBase-input": {
      fontSize: 12,
      padding: "6px 10px",
    },
    "& .MuiInputLabel-root": { fontSize: 12 },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e2e8f0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1976d2",
    },
  };

  const actionButtonSx = {
    flex: { xs: 1, sm: "initial" },
    backgroundColor: "#007bff",
    color: "white",
    textTransform: "none",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 2,
    px: 2,
    py: 0.7,
    minHeight: 38,
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.25)",
    "&:hover": {
      backgroundColor: "#0056b3",
      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.35)",
    },
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 1.5, md: 2 }, backgroundColor: "#f4f7fb", minHeight: "100vh" }}>
      {/* ============ HEADER CARD ============ */}
      <Box
        sx={{
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          borderLeft: { xs: "4px solid #1976d2", sm: "4px solid #1976d2" },
          borderRadius: 3,
          boxShadow: "0 4px 16px rgba(25, 118, 210, 0.08)",
          p: { xs: 1.5, sm: 2 },
          mb: 2,
        }}
      >
        {/* -------- Top Row: Title -------- */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 2,
                backgroundColor: "#e3f2fd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AssignmentTurnedInIcon sx={{ color: "#1976d2", fontSize: 20 }} />
            </Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { xs: 15, sm: 17 },
                color: "#16324f",
                lineHeight: 1.1,
              }}
            >
              Job Allocation
            </Typography>
          </Box>

          {/* Small badge showing count */}
          <Chip
            label={`${jobData.length} Jobs`}
            size="small"
            sx={{
              fontSize: 11,
              height: 22,
              backgroundColor: "#e3f2fd",
              color: "#1976d2",
              fontWeight: 600,
            }}
          />
        </Box>

        {/* -------- Middle Row: Date + Contractor -------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.2,
            mb: 1.5,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  sx: fieldSx,
                },
              }}
            />
          </LocalizationProvider>

          <FormControl size="small" fullWidth sx={fieldSx}>
            <InputLabel id="contractor-label" sx={{ fontSize: 12 }}>
              Contractor
            </InputLabel>
            <Select
              labelId="contractor-label"
              value={contractorCode}
              label="Contractor"
              onChange={(event) => setContractorCode(event.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 260,
                    "& .MuiMenuItem-root": {
                      fontSize: 11,
                      minHeight: 32,
                      py: 0.6,
                    },
                  },
                },
              }}
              sx={{
                "& .MuiSelect-select": {
                  fontSize: 12,
                  padding: "8px 10px",
                  paddingRight: "32px !important",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                },
                "& .MuiSelect-icon": {
                  right: 8,
                  fontSize: 20,
                  color: "#1976d2",
                  pointerEvents: "none",
                },
              }}
            >
              {contractors.map((contractor) => (
                <MenuItem
                  key={contractor.code}
                  value={String(contractor.code)}
                  sx={{ fontSize: 11 }}
                >
                  {contractor.name || contractor.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* -------- Bottom Row: Action Buttons -------- */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexDirection: { xs: "row", sm: "row" },
          }}
        >
          <Button
            variant="contained"
            onClick={() => handleOpenModal("attendance")}
            startIcon={<EventAvailableIcon sx={{ fontSize: 16 }} />}
            sx={actionButtonSx}
          >
            Attendance
          </Button> 
          <Button
            variant="contained"
            onClick={handleViewAllocatedEmployees}
            startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
            sx={actionButtonSx}
            disabled={!contractorCode || !selectedDate}
          >
            View
          </Button>
          <Button
            variant="contained"
            onClick={() => handleOpenModal("new")}
            startIcon={<AddCircleOutlineIcon sx={{ fontSize: 16 }} />}
            sx={actionButtonSx}
          >
            New
          </Button>
        </Box>
      </Box>

      {/* ============ JOB CARD ============ */}
      <JobCard
        jobData={jobData}
        unassignedList={unassignedList}
        selectedDate={selectedDate}
        contractorCode={contractorCode}
      />

      {/* ============ MODAL ============ */}
      <BootstrapDialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={openModal}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth:
              modalType === "allocated"
                ? { xs: "calc(100% - 16px)", sm: 960 }
                : 520,
            margin: { xs: 1, sm: 1.5 },
          },
        }}
      >
        <DialogContent>
          {modalType === "allocated" && (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  mb: 1.5,
                }}
              >
                <Typography sx={{ fontWeight: 700, color: "#16324f" }}>
                  Allocated Employees
                </Typography>
                {!allocatedEmployeesLoading && !allocatedEmployeesError && (
                  <Chip
                    label={`${allocatedEmployees.length} Employees`}
                    size="small"
                    color="primary"
                  />
                )}
              </Box>
              {allocatedEmployeesLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
                  <CircularProgress size={28} />
                </Box>
              ) : allocatedEmployeesError ? (
                <Typography role="alert" color="error" sx={{ py: 2 }}>
                  {allocatedEmployeesError}
                </Typography>
              ) : allocatedEmployees.length === 0 ? (
                <Typography color="text.secondary" sx={{ py: 2 }}>
                  No allocated employees found for this date and contractor.
                </Typography>
              ) : (
                <TableContainer sx={{ maxHeight: "78vh", overflowX: "auto" }}>
                  <Table
                    size="small"
                    stickyHeader
                    sx={{
                      minWidth: 580,
                      "& .MuiTableCell-root": {
                        px: { xs: 0.25, sm: 1.25 },
                        py: { xs: 0.45, sm: 0.9 },
                        fontSize: { xs: 11, sm: 12 },
                        lineHeight: 1.25,
                        whiteSpace: "nowrap",
                      },
                      "& .employee-name": {
                        fontSize: { xs: 8.5, sm: 11 },
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        {["EWO No","Job No", "Barcode", "Employee", "In Time", "Out Time",  "Location"].map((heading) => (
                          <TableCell
                            key={heading}
                            sx={{ fontWeight: 700, backgroundColor: "#f4f7fb" }}
                          >
                            {heading}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allocatedEmployees.map((employee, index) => (
                        <TableRow key={`${employee.AS_BarCodeNo}-${employee.AS_SerialNo || index}`}>
                          <TableCell>{employee.SEA_EWO_NO || "—"}</TableCell>
                          <TableCell>{employee.JobNo || "—"}</TableCell>
                          <TableCell>{employee.AS_BarCodeNo || "—"}</TableCell>
                          <TableCell className="employee-name">
                            {employee.AS_Name || "—"}
                          </TableCell>
                          <TableCell>{formatTime(employee.AS_InTime)}</TableCell>
                          <TableCell>{formatTime(employee.AS_OutTime)}</TableCell>
                          {/* <TableCell>{employee.AS_SerialNo || "—"}</TableCell> */}
                          
                          <TableCell>{employee.SED_LOC_CODE || "—"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}
          {modalType === "attendance" && (
            <JobAllocationAttendence
              onClose={handleCloseModal}
              selectedDate={selectedDate.format("YYYY-MM-DD")}
              contractorCode={contractorCode}
            />
          )}
          {modalType === "new" && (
            <WorkOrderModal
              onClose={handleCloseModal}
              contractorCode={contractorCode}
            />
          )}
        </DialogContent>
      </BootstrapDialog>
    </Box>
  );
};

export default Job_Allocation;